/*
 *  posting-app.js v1.0.6
 *  Copyright (c) 2020 www.11185.cn
 */

function PostingApp() {
  var that = this;
  this.indexCount = 1000;
  this.callAppMap = {};
  this.onPressBackKey = null;
  window.callHtml5 = function(callAppIndex, stringResult) {
    that.appCall(callAppIndex, stringResult);
  };
}

PostingApp.prototype.getAppIndex = function() {
  return this.indexCount++;
};

PostingApp.prototype.callApp = function(type, data, callback) {
  var appIndex = this.getAppIndex();
  if (callback) {
    this.callAppMap[appIndex] = callback;
  }
  window.Emp.execute("callApp(" + appIndex + ",'" + type + "','" + data + "')");
};

PostingApp.prototype.appCall = function(callAppIndex, stringResult) {
  if (this.callAppMap[callAppIndex]) {
    this.callAppMap[callAppIndex](stringResult);
    this.callAppMap[callAppIndex] = null;
    delete this.callAppMap[callAppIndex];
  }
};

//获取分组后的数据
PostingApp.prototype.getFromAppArray = function(
  count,
  filename,
  callback,
  index
) {
  if (!index) {
    index = 0;
  }
  console.log(count + " = " + index);
  if (index < count) {
    this.callApp("getFromAppArray", index, function(result) {
      callback(result, filename, function() {
        if (index < count) {
          postingApp.getFromAppArray(count, filename, callback, index + 1);
        }
      });
    });
  } else {
    this.clearFromAppArray(function() {
      console.log("文件名");
      console.log(filename);
      callback(null, filename);
    });
  }
};

//清理分组后的数据
PostingApp.prototype.clearFromAppArray = function(callback) {
  this.callApp("clearFromAppArray", "", function(result) {
    if (callback) {
      callback(result);
    }
  });
};

//退回应用
PostingApp.prototype.goBack = function() {
  this.callApp("goback", "");
};

//定位坐标 百度坐标
PostingApp.prototype.position = function(callback) {
  this.callApp("autoPosition", "", callback);
};

//打开录音
PostingApp.prototype.recording = function(callback) {
  this.callApp("recording", "", callback);
};

//打开电话面板
PostingApp.prototype.callPhone = function(code) {
  this.callApp("call-phone", code);
};

//重新加载页面如果第三方session过期
PostingApp.prototype.reload = function() {
  this.callApp("reload", "");
};

//刷新页面
PostingApp.prototype.refresh = function() {
  this.callApp("refresh", "");
};

//扫码
PostingApp.prototype.codeScanner = function(callback) {
  this.callApp("codeScanner", "", callback);
};

//打开录音
PostingApp.prototype.startRecord = function(callback) {
  this.callApp("startRecord", "", callback);
};

//完成录音
PostingApp.prototype.completeRecord = function(callback) {
  this.callApp("completeRecord", "", callback);
};

//取消录音
PostingApp.prototype.cancelRecord = function(callback) {
  this.callApp("cancelRecord", "", callback);
};

//判断录音状态
PostingApp.prototype.isRecord = function(callback) {
  this.callApp("isRecord", "", callback);
};

//从相册选择，可以选择图片也可以选择视频， 如果是图片width生效，视频不压缩, 如果width传输null就是不压缩图片
PostingApp.prototype.selectCameraPhoto = function(width, callback) {
  if (!width) {
    width = "";
  }
  this.callApp("selectCameraPhoto", width, function(r) {
    var obj = JSON.parse(r);
    postingApp.getFromAppArray(obj.count, obj.filename, callback);
  });
};

//从相册选择，参数1 mediaType， 参数2 width， 如果是图片width生效，视频不压缩, 如果width传输null就是不压缩图片, mediaType类型为image或video
//android9及以上，不区分图片和视频，所以如果系统是9以上的传的是image用户也可能选择的是video，要通过callbak中返回的文件名做判断
//android9以下，是区分图片和视频
PostingApp.prototype.selectCameraPhoto2 = function(mediaType, width, callback) {
  if (!width) {
    width = "";
  }
  if (!mediaType) {
    mediaType = "image";
  }
  this.callApp(
    "selectCameraPhoto2",
    JSON.stringify({ width, mediaType }),
    function(r) {
      var obj = JSON.parse(r);
      postingApp.getFromAppArray(obj.count, obj.filename, callback);
    }
  );
};

//拍照图片 quality low|high
PostingApp.prototype.startCameraPhoto = function(quality, callback) {
  this.callApp("startCameraPhoto", quality, function(r) {
    var obj = JSON.parse(r);
    postingApp.getFromAppArray(obj.count, obj.filename, callback);
  });
};

//拍照图片 quality low|high width 如果是图片width生效，width传输null就是不压缩图片
PostingApp.prototype.startCameraPhoto2 = function(quality, width, callback) {
  if (!width) {
    width = "";
  }
  this.callApp(
    "startCameraPhoto2",
    JSON.stringify({ quality, width }),
    function(r) {
      var obj = JSON.parse(r);
      postingApp.getFromAppArray(obj.count, obj.filename, callback);
    }
  );
};

//录制视频 quality low|high
PostingApp.prototype.startCameraVideo = function(quality, callback) {
  this.callApp("startCameraVideo", quality, function(r) {
    var obj = JSON.parse(r);
    postingApp.getFromAppArray(obj.count, obj.filename, callback);
  });
};

PostingApp.prototype.copyToClipboard = function(data, callback) {
  this.callApp("copyToClipboard", data, function(r) {
    callback(r);
  });
};

PostingApp.prototype.changeBarColor = function(data, callback) {
  this.callApp("changeBarColor", data, function(r) {
    callback(r);
  });
};

PostingApp.prototype.openBrowser = function(data, callback) {
  this.callApp("openBrowser", data, function(r) {
    callback(r);
  });
};

//保存图片到相册 data参数是图片url的绝对地址
PostingApp.prototype.savePictureToAlbum = function(data, callback) {
  this.callApp("savePictureToAlbum", data, function(r) {
    callback(r);
  });
};

PostingApp.prototype.pressBackKey = function() {
  if (this.onPressBackKey) {
    this.onPressBackKey();
  }
};

// 微信分享
PostingApp.prototype.shareLink = function(data, callback) {
  this.callApp("shareLink", data, callback);
};

var postingApp = new PostingApp();

function handleShareLink() {
  postingApp.shareLink(function(result) {
    console.log(result);
  });
}

function handleGoBack() {
  postingApp.goBack();
}

function handlePosition() {
  postingApp.position(function(result) {
    console.log(result);
  });
}

function handleRecording() {
  postingApp.recording(function(result) {
    console.log(result);
  });
}

function handleCallPhone() {
  postingApp.callPhone("18800000000");
}

function handleReload() {
  postingApp.reload();
}

function handleRefresh() {
  postingApp.refresh();
}

function handleCodeScanner() {
  postingApp.codeScanner(function(result) {
    //result 可能出现"扫码识别"
    console.log(result);
  });
}

//开始录音
function handleStartRecord() {
  postingApp.startRecord(function(result) {
    console.log(result);
  });
}

//录音完成
function handleCompleteRecord() {
  postingApp.completeRecord(function(result) {
    console.log(result);
  });
}

//取消录音
function handleCancelRecord() {
  postingApp.cancelRecord(function(result) {
    console.log(result);
  });
}

//录音状态
function handleIsRecord() {
  postingApp.isRecord(function(result) {
    console.log(result);
  });
}

//先注册方法监控回退键
window.postingApp = postingApp;
postingApp.onPressBackKey = function() {
  console.log("回退按钮");
};

//从相册选择，可以选择图片也可以选择视频， 如果是图片width生效，视频不压缩, 如果width传输null就是不压缩图片
function handleSelectCameraPhoto() {
  //content是文件的base64字符串
  var content = "";
  //filename是选择的文件名
  postingApp.selectCameraPhoto("100", (result, filename, next) => {
    if (result != null) {
      content += result;
      //因为文件可能很大所以要分段取
      next();
    } else {
      //如果result返回null证明已经取完了
      var allContent = content;
    }
  });
}

//从相册选择，参数1 mediaType， 参数2 width， 如果是图片width生效，视频不压缩, 如果width传输null就是不压缩图片, mediaType类型为image或video
//android9及以上，不区分图片和视频，所以如果系统是9以上的传的是image用户也可能选择的是video，要通过callbak中返回的文件名做判断
//android9以下，是区分图片和视频
function handleSelectCameraPhoto2() {
  //content是文件的base64字符串
  var content = "";
  //filename是选择的文件名
  postingApp.selectCameraPhoto2("image", "100", (result, filename, next) => {
    if (result != null) {
      content += result;
      //因为文件可能很大所以要分段取
      next();
    } else {
      //如果result返回null证明已经取完了
      var allContent = content;
    }
  });
}

//拍照图片 quality low|high
function handleStartCameraPhoto() {
  //content是文件的base64字符串
  var content = "";
  //filename是选择的文件名
  postingApp.startCameraPhoto("low", (result, filename, next) => {
    if (result != null) {
      content += result;
      //因为文件可能很大所以要分段取
      next();
    } else {
      //如果result返回null证明已经取完了
      var allContent = content;
    }
  });
}

//拍照图片 quality low|high
function handleStartCameraPhoto2() {
  //content是文件的base64字符串
  var content = "";
  //filename是选择的文件名
  postingApp.startCameraPhoto("high", "100", (result, filename, next) => {
    if (result != null) {
      content += result;
      //因为文件可能很大所以要分段取
      next();
    } else {
      //如果result返回null证明已经取完了
      var allContent = content;
    }
  });
}

//录制视频 quality low|high
function handleStartCameraVideo() {
  //content是文件的base64字符串
  var content = "";
  //filename是选择的文件名
  postingApp.startCameraVideo("low", (result, filename, next) => {
    if (result != null) {
      content += result;
      //因为文件可能很大所以要分段取
      next();
    } else {
      //如果result返回null证明已经取完了
      var allContent = content;
    }
  });
}

//添加到剪切板
function handleCopyToClipboard() {
  postingApp.copyToClipboard("你好", (result) => {
    console.log(result);
  });
}

//改变bar颜色
function handleChangeBarColor() {
  postingApp.changeBarColor("#000000", (result) => {
    console.log("result", result);
  });
}

//在浏览器中打开
function handleOpenBrowser() {
  postingApp.openBrowser("http://192.168.137.1/static/aaa.rar", (result) => {
    console.log(result);
  });
}

//保存图片到相册
function handleSavePictureToAlbum() {
  postingApp.savePictureToAlbum(
    "https://dss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/topnav/yinyue@2x-c18adacacb.png",
    (result) => {
      console.log(result);
    }
  );
}

export default postingApp;
